import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  instructorRequest: [
    {
      /* sectionNumber: "kkk-1",
      sectionName: "Morning",
      profFirtsName: "Old",
      profLastName: "Die", */
    },
  ],
};

const slice = createSlice({
  name: "request",
  initialState,

  reducers: {
    setInstructorRequest: (state, action) => {
      state.instructorRequest = action.payload;
    },
    resetInstructorRequest: (state) => {
      state = initialState;
    },
  },
});

export const { setInstructorRequest, resetInstructorRequest } = slice.actions;
export default slice.reducer;
